import { Link, createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LuPlus } from "react-icons/lu";

import {
  LinkGroup,
  OrganizationTable,
  PageName,
  PageNumberController,
  PageSizeSelector,
} from "#components";
import { useListedOrganizations } from "#services";
import { css } from "#styled-system/css";

export const Route = createFileRoute("/_authenticated/management/organizations/")({
  component: Component,
});

function Component() {
  const { t } = useTranslation();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const { fetchNextPage, loaded, loading, pages } = useListedOrganizations({ limit: pageSize });

  const organizations = pages.at(Math.min(pageNumber, pages.length - 1))?.organizations;

  return (
    <main className={css({ display: "flex", flexDirection: "column" })}>
      <PageName>{t("%OrganizationManagement.0%")}</PageName>

      <p className={css({ fontSize: "24px", fontWeight: 700 })}>{t("%CustomerManagement.0%")}</p>

      <LinkGroup
        className={css({ marginTop: "16px" })}
        links={[
          {
            available: true,
            label: t("%OrganizationInformation.0%"),
            path: "/management/organizations",
          },
          {
            available: true,
            label: t("%FacilityInformation.0%"),
            path: "/management/facilities",
          },
        ]}
      />

      <div
        className={css({
          alignItems: "flex-end",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
        })}
      >
        <div></div>
        <div>
          <Link
            className={css({ alignItems: "center", display: "flex", gap: "8px" })}
            to="/management/organizations/registration"
          >
            <LuPlus />
            <p>{t("%AddOrganization.0%")}</p>
          </Link>
        </div>
      </div>

      <div className={css({ flex: 1, marginTop: "16px", overflowX: "auto", width: "100%" })}>
        <OrganizationTable
          className={css({ height: "100%" })}
          loading={loading}
          organizations={organizations}
        />
      </div>

      <div
        className={css({
          alignItems: "flex-start",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
        })}
      >
        <PageNumberController
          loading={loading}
          next={pageNumber < pages.length || !loaded}
          onNext={function (value) {
            if (value >= pages.length - 1 && !loaded) {
              fetchNextPage().then(function () {
                setPageNumber(value);
              });
            }
          }}
          onPrevious={function (value) {
            setPageNumber(value);
          }}
          value={pageNumber}
        />
        <PageSizeSelector
          onChange={function (value) {
            setPageSize(value);
          }}
          options={[25, 50, 100]}
          value={pageSize}
        />
      </div>
    </main>
  );
}
